<template>
    <div>
        <div :class="`imgs-slide imgs-slide-${random}`">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="src in srcs" :key="src">
                        <v-responsive :aspect-ratio="1200 / 675">
                            <img v-bind="{ src }" width="100%" height="100%" class="d-block" style="object-fit: cover;">
                        </v-responsive>
                    </div>
                </div>
                <div class="swiper-control">
                    <button class="swiper-prev"><i class="icon icon-left-arrow-circle"></i></button>
                    <button class="swiper-next"><i class="icon icon-right-arrow-circle"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper/bundle";

export default {
    props: {
        srcs: { type: Array, default: () => [] },
    },
    data: () => ({
        random: Math.random().toFixed(10).slice(2, 12),
        swiper: undefined,
        selectedIndex: 0,
        Math,
    }),
    computed: {
        disable_prev() {
            return this.selectedIndex < 1;
        },
        disable_next() {
            return this.selectedIndex >= this.srcs.length - 1;
        },
    },
    watch: {
        showsDialog() {
            this.$refs["nav"]?.$forceUpdate?.();
            this.$nextTick(() => this.$refs?.["nav"]?.setWidths?.());
            this.init();
        },
        selectedIndex() {
            if (this.selectedIndex >= this.srcs.length) this.selectedIndex = this.srcs.length - 1;
            if (this.selectedIndex < 0) this.selectedIndex = 0;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        setIndex(index) {
            this.selectedIndex = index;
        },
        goPrev() {
            if (this.selectedIndex > 0) this.selectedIndex -= 1;
        },
        goNext() {
            if (this.selectedIndex < this.srcs.length - 1) this.selectedIndex += 1;
        },
        async init() {
            this.$nextTick(() => {
                new Swiper(`.imgs-slide-${this.random} .swiper-container`, {
                    effect: 'fade',
                    allowTouchMove: true,
                    centeredSlides: true,
                    spaceBetween: 24,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                    navigation: {
                        nextEl: ".imgs-slide .swiper-next",
                        prevEl: ".imgs-slide .swiper-prev",
                    },
                });
            });
        },
    },
};
</script>
